/**
 * MAP PROXY WMTS LAYERS
 */

export function buildWmtsLayer(proxyId, zIndex) {
    if(zIndex == undefined || zIndex == null)
        zIndex = 50;
    return {
      "url": `${proxyId}/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png`,
      "z-index": zIndex,
      "tokenKey": "Timmons MapProxy"
    };
  }

  export var defaultExtent = [
    -20037508.3428,
    -20037508.3428,
    20037508.3428,
    20037508.3428
  ];